import $ from 'jquery'

// Store all rotating text circle instances
const rotatingTextCircles = []

// Global mouse tracking for all rotating text circles
let globalLastMouseX = 0
let isMouseTrackingInitialized = false

function initGlobalMouseTracking() {
  if (isMouseTrackingInitialized) return
  isMouseTrackingInitialized = true

  $(document).on('mousemove.rotatingTextCircle', function (e) {
    const currentMouseX = e.pageX

    if (globalLastMouseX !== 0) {
      const deltaX = currentMouseX - globalLastMouseX

      if (Math.abs(deltaX) > 0.5) {
        // Update all rotating text circles
        rotatingTextCircles.forEach(function (instance) {
          const rotationSpeed = -deltaX * 0.3 // Speed multiplier (inverted)
          instance.rotation += rotationSpeed

          // Apply rotation to the container
          instance.$wrapper.css('transform', `rotate(${instance.rotation}deg)`)
        })
      }
    }

    globalLastMouseX = currentMouseX
  })

  // Initialize on first mouse move
  $(document).one('mousemove.rotatingTextCircle', function (e) {
    globalLastMouseX = e.pageX
  })
}

$(document).ready(function () {
  dhsv_vc_rotating_text_circle()
})

function dhsv_vc_rotating_text_circle() {
  // Initialize global mouse tracking once
  initGlobalMouseTracking()

  $('.dhsv_vc_rotating_text_circle').each(function () {
    const $element = $(this)
    const $wrapper = $element.find(
      '.dhsv_vc_rotating_text_circle__text-wrapper'
    )
    const $chars = $element.find('.dhsv_vc_rotating_text_circle__char')

    if ($chars.length === 0) return

    const instance = {
      rotation: 0,
      $wrapper: $wrapper,
    }

    // Get text from characters
    const text = $chars
      .map(function () {
        return $(this).text().trim() || ' '
      })
      .get()
      .join('')
      .trim()

    if (!text) return

    const fontSize = 32 // px
    const letterSpacing = 5 // px

    // Measure actual text width by creating a temporary element
    const $tempText = $('<span>')
      .css({
        position: 'absolute',
        visibility: 'hidden',
        fontSize: fontSize + 'px',
        letterSpacing: letterSpacing + 'px',
        fontFamily: 'inherit',
        whiteSpace: 'nowrap',
        lineHeight: '1',
      })
      .text(text)
      .appendTo('body')

    const actualTextWidth = $tempText.outerWidth()
    const actualTextHeight = $tempText.outerHeight() || fontSize
    $tempText.remove()

    // Calculate radius so that circumference = text width
    // circumference = 2 * π * radius
    // radius = circumference / (2 * π)
    // Apply a multiplier to make the circle smaller (0.85 = 15% smaller)
    const radius = (actualTextWidth / (2 * Math.PI)) * 1

    // Ensure minimum radius for readability
    const minRadius = 40
    const finalRadius = Math.max(minRadius, radius)

    // Calculate angle per character
    // Distribute characters evenly around 360 degrees
    const totalAngle = 360
    const anglePerChar = totalAngle / $chars.length

    // Position each character around the circle
    $chars.each(function (index) {
      const $char = $(this)
      const angle = index * anglePerChar
      const angleRad = (angle * Math.PI) / 180

      // Calculate position on circle
      const x = Math.cos(angleRad) * finalRadius
      const y = Math.sin(angleRad) * finalRadius

      // Position character and rotate it to face outward
      // Add 90 degrees to make text face outward from center
      $char.css({
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(${
          angle + 90
        }deg)`,
        transformOrigin: 'center center',
        letterSpacing: '0', // Remove letter-spacing since we're positioning manually
      })
    })

    // After positioning, animate characters to visible
    // Use a small delay for each character to create a nice reveal effect
    $chars.each(function (index) {
      const $char = $(this)
      setTimeout(function () {
        $char.addClass('is-visible')
      }, index * 20) // 20ms delay between each character
    })

    // Set container size to accommodate the circle + text height
    // Add generous padding to ensure text is never clipped during rotation
    const textHeight = actualTextHeight
    const padding = Math.max(30, textHeight / 2 + 30)
    const containerSize = (finalRadius + padding) * 2
    $wrapper.css({
      width: containerSize + 'px',
      height: containerSize + 'px',
      position: 'relative',
    })

    // Add this instance to the global array for mouse tracking
    rotatingTextCircles.push(instance)
  })
}
